import { cloneDeep } from 'lodash';
import ServerMessaging from '_acaSrc/utility/ServerMessaging';
import UtdCache from '_acaSrc/utility/UtdCache';
import utdRest from '../utility/http/UtdRestHooks';
import PubSub from '_acaSrc/utility/PubSub';
import {
    SET_SEARCHBAR_DISABLE_AC,
    SET_SEARCH_STATE
} from '_acaSrc/store/search.store';
import { SET_KEEP_ONE_ACCOUNT_REQUEST } from '_acaSrc/store/profile.store';
import { SET_MYACCOUNT_SIDEBAR_REQUEST } from '_acaSrc/store/app.store';
import {
    SET_PERSISTENT_LOGIN_MODAL_SHOWN,
    SET_PERSISTENT_LOGIN_MODAL_PENDING,
    SET_PERSISTENT_LOGIN_RESOLVE_MODAL,
    SET_PERSISTENT_LOGIN_ACTIVE_PROMISE
} from '_acaSrc/store/auth.store';
import {
    SET_ERROR_MESSAGE,
    SET_ERROR_TITLE
} from '_acaSrc/store/error.store';
import {
    C_MY_ACCOUNT,
    C_HTTP, C_REG_MERGE,
    C_DEFAULT_PREFERENCE,
    C_LOGIN_WORKFLOW,
    C_PRIORITY_LOGIN
} from '_acaSrc/utility/constants';
import { getWindow } from '_acaSrc/utility/DOM';
import { setQueryParamValue } from '_acaSrc/utility/http';
import { getCookie, deleteCookie } from '_acaSrc/utility/Cookies';

const state = {
    form: {
        userName: '',
        password: '',
        saveUserName: false,
        isSubmitting: false
    },
    origForm: {
        userName: '',
        password: '',
        saveUserName: false,
        isSubmitting: false
    },
    message: {
        title: '',
        error: '',
        level: 'error'
    },
    origMessage: {
        error: ''
    },
    loginErrorMessage: {
        message: '',
        title: ''
    },    
    tier2: {},
    institutions: [],
    postLoginUrl: '',
    isExpertAiRedirect: false,
    expertAiRedirectUrl: '',
    loginSubscriberBox: false,
    loginRegisterButton: false,
    renewalSubscriptionUrl: '',
    loginHref: '/login',
    isRegister: false,
    skipLinkUrl: '',
    loginInfoMessage: {
        title: '',
        error: '',
        level: ''
    },
    isNextStepsFlow: false,
    shouldRedirectPostSSO: false,
    registrationInfo: {
        canContinueWithSearch: false,
        continueWithSearchLink: '',
        coBrandingLogoURL: '',
        coBrandingMessage: '',
        coBrandingHeader: '',
        isTwoFactorEnabled: true,
        isTwoFactorDeferred: false,
        twoFactorEmailVerificationMaxCodesPerSession: null
    },
    registrationForm: {
        formName: '',
        formFields: {},
        isLoaded: false,
        isSuccess: false,
        shouldSuggestMerge: false
    },
    oidcMergeStatus: '',
    oidcMergePreviewSummary: null,
    mergeProfile: {},
    pendingRegisterForm: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        registrationUserName: '',
        verifyPassword: '',
        country: ''
    }
};


export const getters = {
    form: state => state.form,
    origForm: state => state.origForm,
    message: state => state.message,
    origMessage: state => state.origMessage,
    tier2: state => state.tier2,
    institutions: state => state.institutions,
    postLoginUrl: state => state.postLoginUrl,
    isExpertAiRedirect: state => state.isExpertAiRedirect,
    expertAiRedirectUrl: state => state.expertAiRedirectUrl,
    loginSubscriberBox: state => state.loginSubscriberBox,
    loginRegisterButton: state => state.loginRegisterButton,
    renewalSubscriptionUrl: state => state.renewalSubscriptionUrl,
    loginHref: state => state.loginHref,
    isRegister: state => state.isRegister,
    skipLinkUrl: state => state.skipLinkUrl,
    loginErrorMessage: state => state.loginErrorMessage,
    loginInfoMessage: state => state.loginInfoMessage,
    isNextStepsFlow: state => state.isNextStepsFlow,
    shouldRedirectPostSSO: state => state.shouldRedirectPostSSO,
    registrationInfo: state => state.registrationInfo,
    registrationForm: state => state.registrationForm,
    visibleRegFormFields: state => {
        const formFields = state.registrationForm.formFields;
        return Object.keys(formFields);
    },
    oidcMergeStatus: state => state.oidcMergeStatus,
    oidcMergePreviewSummary: state => state.oidcMergePreviewSummary,
    mergeProfile: state => state.mergeProfile,
    pendingRegisterForm: state => state.pendingRegisterForm
};

export const SET_MESSAGE_ERROR = 'SET_MESSAGE_ERROR';
export const SET_INSTITUTIONS = 'SET_INSTITUTIONS';
export const SET_MESSAGE_TITLE = 'SET_MESSAGE_TITLE';
export const SET_MESSAGE = 'SET_MESSAGE';
export const SET_FORM_SUBMITTING = 'SET_FORM_SUBMITTING';
export const SET_POST_LOGIN_URL = 'SET_POST_LOGIN_URL';
export const SET_FORM_POST_LOGIN_URL = 'SET_FORM_POST_LOGIN_URL';
export const SET_IS_EXPERT_AI_REDIRECT = 'SET_IS_EXPERT_AI_REDIRECT';
export const SET_EXPERT_AI_REDIRECT_URL = 'SET_EXPERT_AI_REDIRECT_URL';
export const SET_FORM = 'SET_FORM';
export const SET_FORM_PASSWORD = 'SET_FORM_PASSWORD';
export const SET_FORM_USER_NAME = 'SET_FORM_USER_NAME';
export const SET_FORM_SAVE_USER_NAME = 'SET_FORM_SAVE_USER_NAME';
export const SET_LOGIN_SUBSCRIBER_BOX = 'SET_LOGIN_SUBSCRIBER_BOX';
export const SET_LOGIN_REGISTER_BUTTON = 'SET_LOGIN_REGISTER_BUTTON';
export const SET_RENEWAL_SUBSCRIPTION_URL = 'SET_RENEWAL_SUBSCRIPTION_URL';
export const SET_LOGIN_HREF_AND_IS_REGISTER = 'SET_LOGIN_HREF_AND_IS_REGISTER';
export const SET_SKIP_LINK_URL = 'SET_SKIP_LINK_URL';
export const SET_LOGIN_ERROR_MESSAGE = 'SET_LOGIN_ERROR_MESSAGE';
export const RESET_LOGIN_ERROR_MESSAGE = 'RESET_LOGIN_ERROR_MESSAGE';
export const SET_LOGIN_INFO_MESSAGE = 'SET_LOGIN_INFO_MESSAGE';
export const SET_ERROR_LEVEL = 'SET_ERROR_LEVEL';
export const SET_NEXT_STEPS_FLOW = 'SET_NEXT_STEPS_FLOW';
export const SET_SHOULD_REDIRECT_POST_SSO = 'SET_SHOULD_REDIRECT_POST_SSO';
export const SET_REGISTRATION_COBRANDING = 'SET_REGISTRATION_COBRANDING';
export const SET_REGISTRATION_FORM = 'SET_REGISTRATION_FORM';
export const SET_CAN_CONTINUE_WITH_SEARCH = 'SET_CAN_CONTINUE_WITH_SEARCH';
export const SET_CONTINUE_WITH_SEARCH_LINK = 'SET_CONTINUE_WITH_SEARCH_LINK';
export const SET_IS_TWO_FACTOR_ENABLED = 'SET_IS_TWO_FACTOR_ENABLED';
export const SET_IS_TWO_FACTOR_DEFERRED = 'SET_IS_TWO_FACTOR_DEFERRED';
export const SET_TWO_FACTOR_MAX_CODES_PER_SESSION = 'SET_TWO_FACTOR_MAX_CODES_PER_SESSION';
export const SET_SHOULD_SUGGEST_MERGE = 'SET_SHOULD_SUGGEST_MERGE';
export const SET_OIDC_MERGE_STATUS = 'SET_OIDC_MERGE_STATUS';
export const SET_OIDC_MERGE_PREVIEW_SUMMARY = 'SET_OIDC_MERGE_PREVIEW_SUMMARY';
export const SET_MERGED_ACCOUNT_INFO = 'SET_MERGED_ACCOUNT_INFO';
export const SET_PENDING_REGISTER_FORM = 'SET_PENDING_REGISTER_FORM';

export const mutations = {
    [SET_MESSAGE_ERROR]: (state, msg) => {
        state.message.error = msg;
    },
    [SET_ERROR_LEVEL]: (state, value) => {
        state.message.level = value;
    },
    [SET_MESSAGE_TITLE]: (state, msg) => state.message.title = msg,
    [SET_MESSAGE]: (state, msg) => state.message = msg,
    [SET_FORM_SUBMITTING]: (state, isSubmitting) => state.form.isSubmitting = isSubmitting,
    [SET_POST_LOGIN_URL]: (state, url) => state.postLoginUrl = url,
    [SET_FORM_POST_LOGIN_URL]: (state, url) => state.form.postLoginUrl = url,
    [SET_IS_EXPERT_AI_REDIRECT]: (state, isRedirect) => state.isExpertAiRedirect = isRedirect,
    [SET_EXPERT_AI_REDIRECT_URL]: (state, url) => state.expertAiRedirectUrl = url,
    [SET_FORM]: (state, form) => state.form = form,
    [SET_FORM_PASSWORD]: (state, password) => state.form.password = password,
    [SET_FORM_USER_NAME]: (state, userName) => state.form.userName = userName,
    [SET_FORM_SAVE_USER_NAME]: (state, saveUserName) => state.form.saveUserName = saveUserName,
    [SET_INSTITUTIONS]: (state, institutions) => state.institutions = institutions,
    [SET_LOGIN_SUBSCRIBER_BOX]: (state, loginSubscriberBox) =>
        state.loginSubscriberBox = loginSubscriberBox,
    [SET_LOGIN_REGISTER_BUTTON]: (state, loginRegisterButton) =>
        state.loginRegisterButton = loginRegisterButton,
    [SET_RENEWAL_SUBSCRIPTION_URL]: (state, data) => {
        if ('renewalSubscriptionURL' in data) {
            state.renewalSubscriptionUrl = data.renewalSubscriptionURL;
        }
    },
    [SET_LOGIN_HREF_AND_IS_REGISTER]: (state, value) => {
        state.loginHref = value;
         
        if (value == '/login') {
            state.isRegister = false;
        }
        else {
            state.isRegister = true;
        }
    },
    [SET_SKIP_LINK_URL]: (state, value) => {
        if (value) {
            state.skipLinkUrl = value;
        }
    },
    [SET_LOGIN_ERROR_MESSAGE]: (state, data) => {
        state.loginErrorMessage.message = data?.loginErrorMessage;
        state.loginErrorMessage.title = data?.loginErrorTitle;
    },
    [SET_LOGIN_INFO_MESSAGE]: (state, data) => {
        state.loginInfoMessage = data;
    },
    [RESET_LOGIN_ERROR_MESSAGE]: state => state.loginErrorMessage = {
        message: '',
        title: ''
    },   
    [SET_NEXT_STEPS_FLOW]: (state, value) => state.isNextStepsFlow = value,
    [SET_SHOULD_REDIRECT_POST_SSO]: (state, value) => {
        state.shouldRedirectPostSSO = value;
        new UtdCache().setPersistent('shouldRedirectPostSSO', value, 1);
    },
    [SET_REGISTRATION_COBRANDING]: (state, data) => {
        state.registrationInfo.coBrandingLogoURL = data?.coBrandingLogoURL || '';
        state.registrationInfo.coBrandingMessage = data?.coBrandingMessage || '';
        state.registrationInfo.coBrandingHeader = data?.coBrandingHeader || '';
    },
    [SET_REGISTRATION_FORM]: (state, data) => {
        state.registrationForm.formName = data?.formName || '';
        state.registrationForm.formFields = data?.formFields || {};
        state.registrationForm.isSuccess = data?.isSuccess || false;
        state.registrationForm.isLoaded = true;
    },
    [SET_CAN_CONTINUE_WITH_SEARCH]: (state, value) => {
        state.registrationInfo.canContinueWithSearch = value;
    },
    [SET_CONTINUE_WITH_SEARCH_LINK]: (state, value) => {
        state.registrationInfo.continueWithSearchLink = value;
    },
    [SET_IS_TWO_FACTOR_ENABLED]: (state, value) => {
        state.registrationInfo.isTwoFactorEnabled = value;
    },
    [SET_IS_TWO_FACTOR_DEFERRED]: (state, value) => {
        state.registrationInfo.isTwoFactorDeferred = value;
    },
    [SET_TWO_FACTOR_MAX_CODES_PER_SESSION]: (state, value) => {
        state.registrationInfo.twoFactorEmailVerificationMaxCodesPerSession = value;
    },
    [SET_SHOULD_SUGGEST_MERGE]: (state, value) => {
        state.registrationForm.shouldSuggestMerge = value;
    },
    [SET_OIDC_MERGE_STATUS]: (state, data) => {
        state.oidcMergeStatus = data?.oidcMergeStatus || '';
    },
    [SET_OIDC_MERGE_PREVIEW_SUMMARY]: (state, data) => {
        state.oidcMergePreviewSummary = data?.oidcMergePreviewSummary || null;
    },
    [SET_MERGED_ACCOUNT_INFO]: (state, data) => {
        state.mergeProfile = data?.mergeProfile || {};
    },
    [SET_PENDING_REGISTER_FORM]: (state, data) => {
        state.pendingRegisterForm = { ...data };
    }
};

const handleEmailVerificationRequiredLoginError = ({ commit, rootGetters }, loginError) => {
    if (loginError?.title !== 'Email Verification Required') {
        return false;
    }

    commit(`error/${SET_ERROR_MESSAGE}`, loginError.message || '', { root: true });
    commit(`error/${SET_ERROR_TITLE}`, loginError.title, { root: true });
    rootGetters['app/router'].go('viewError');

    return true;
};

export const actions = {
    reset({ commit, getters }) {
        const origForm = cloneDeep(getters.origForm);
        commit(SET_FORM, origForm);
        const origMessage = cloneDeep(getters.origMessage);
        commit(SET_MESSAGE, origMessage);
    },
    logLoginEvent({ rootGetters, dispatch, getters }, isShowCaptchaSection) {
        let src;

        if (getters.loginSubscriberBox) {
            src = 'login-subscribe-view';
        }
        else if (rootGetters['app/productName'] === 'UpToDate \u4E34\u5E8A\u987E\u95EE'
             || rootGetters['app/countryCode'] === 'CN') {
            src = '';
        }
        else {
            src = 'login-register-view';
        }
        dispatch('app/logEvent', {
            eventUrl: 'event/login/json',
            eventParams: {
                source: src,
                isCaptchaSectionVisible: isShowCaptchaSection
            }
        }, { root: true }
        );
    },
    setErrorMessage({ commit }, msg) {
        commit(SET_MESSAGE_ERROR, msg);
    },
    setErrorTitle({ commit }, msg) {
        commit(SET_MESSAGE_TITLE, msg);
    },
    async getLoginWorkflow(_, { username, forceServerCall = false }) {
        const response = { 
            workflow: C_LOGIN_WORKFLOW.PROMPT_USER_FOR_PASSWORD,
            mergeWarning: false
        };
        if (!forceServerCall && !username.includes('@')) {
            return response;
        }
        try {
            const data = await utdRest('wayf/url', {
                userName: username
            });
            const res = data.data || data;
            return res;
        }
        catch {
            return response;
        }
    },
    loginUser: async({ getters, commit, dispatch }) => {
        try {
            // turns off auto complete while login is processing DE9872
            commit(`search/${SET_SEARCHBAR_DISABLE_AC}`, true, { root: true });
            commit('feature/SET_SHOW_PRINT_LINK', {}, { root: true });
            commit('search/SET_MOBILE_WEB_SEARCH_INTERACTION', false, { root: true });

            // check if we have to redirect to Expert AI post-login
            const cache = new UtdCache();
            const expertAiRedirectUrl = cache.getPersistent('expertAiRedirectUrl');
            const isExpertAiRedirect = cache.getPersistent('isExpertAiRedirect');
            if (expertAiRedirectUrl && isExpertAiRedirect) {
                commit(SET_FORM_POST_LOGIN_URL, expertAiRedirectUrl);
                cache.setPersistent('expertAiRedirectUrl', '', 1);
                cache.setPersistent('isExpertAiRedirect', false, 1);
            }
            if (getters.postLoginUrl !== '') {
                commit(SET_FORM_POST_LOGIN_URL, getters.postLoginUrl);
                commit(SET_POST_LOGIN_URL, '');
            }
            if (!getters.form.postLoginUrl) {
                const pathwayExternalRedirectUrl =
                    cache.getSession(C_PRIORITY_LOGIN.PATHWAY_REDIRECT_CACHE_KEY)
                    || getCookie(C_PRIORITY_LOGIN.PATHWAY_REDIRECT_CACHE_KEY);
                if (pathwayExternalRedirectUrl) {
                    commit(SET_FORM_POST_LOGIN_URL, pathwayExternalRedirectUrl);
                    cache.removeSession(C_PRIORITY_LOGIN.PATHWAY_REDIRECT_CACHE_KEY);
                    deleteCookie(C_PRIORITY_LOGIN.PATHWAY_REDIRECT_CACHE_KEY, { path: '/' });
                }
            }

            const data = await utdRest('auth/login', getters.form);
            await dispatch('processLogin', data);
            return data;
        }
        catch (err) {
            dispatch('processFailedLogin', err);
        }
    },
    ssoMerge({ getters, commit, dispatch }) {
        return utdRest('auth/ssoMerge', getters.form)
            .then(() => {
                commit(SET_MESSAGE_ERROR, '');
                commit(`profile/${SET_KEEP_ONE_ACCOUNT_REQUEST}`, false, { root: true });
            })
            .catch(error => {
                dispatch('processFailedLogin', error);
            });
    },
    processFailedLogin({ commit, rootGetters }, error) {
        const errorData = error.data;
        const loginError = errorData?.errors?.[0];

        if (handleEmailVerificationRequiredLoginError({ commit, rootGetters }, loginError)) {
            return;
        }

        if (errorData && errorData.errors && errorData.errors.length) {
            commit(SET_MESSAGE_ERROR, errorData.errors[0].message);
            commit(SET_MESSAGE_TITLE, errorData.errors[0].title);
        }

        commit(SET_FORM_PASSWORD, '');
        commit(`search/${SET_SEARCHBAR_DISABLE_AC}`, false, { root: true });
    },
    async processLogin({ rootGetters, getters, commit, dispatch }, data) {
        dispatch('app/resetUI', { preventScrollTop: false }, { root: true });
        const url = rootGetters['app/getDestinationUrl'];
        new PubSub().publish('wkutd.purgePersistentCache');
        // If url is not empty, push it back into cache so that
        // the TwoFactor service can find it if needed.
        if (url) {
            new UtdCache().setPersistent('utdDestinationUrl', url, 1);
        }

        if (rootGetters['profile/userProfile'].pendoStateMessage === '') {
            dispatch('pendo/initializePendo', '', { root: true });
        }

        const searchState = rootGetters['search/searchResultsState'];
        commit(`search/${SET_SEARCH_STATE}`, searchState, { root: true });

        // If the user has an email as their username,
        // they will log in via the Next Steps for Sign In process to create two accounts
        // so they should not go through the normal login flow
        if (getters.isNextStepsFlow) {
            return;
        }
        const origForm = cloneDeep(getters.origForm);
        commit(SET_FORM, origForm);
        commit(SET_MESSAGE_ERROR, '');

        dispatch('footer/getFooter', '', { root: true });

        // Disable GA4 analytics script
        getWindow().dataLayer = [];

        dispatch('handleMyAccountSidebar');

        await postProcessLogin({ rootGetters, dispatch }, data, url);
    },
    handleMyAccountSidebar({ commit, rootGetters }) {
        if (rootGetters['app/myAccountSidebarRequestStatus']
        === C_MY_ACCOUNT.SIDEBAR_REQUEST.PENDING) {
            commit(`app/${SET_MYACCOUNT_SIDEBAR_REQUEST}`,
                C_MY_ACCOUNT.SIDEBAR_REQUEST.APPROVED, { root: true });
        }
    },
    setOidcPartnerModalShown({ rootGetters }) {
        rootGetters['auth/oidcPartnerDetails'].modalConfig.shown = true;
    },
    handlePersistentLoginModalShown({ commit }) {
        commit(`auth/${SET_PERSISTENT_LOGIN_MODAL_PENDING}`, true, { root: true });
        const promise = new Promise(resolve => {
            commit(`auth/${SET_PERSISTENT_LOGIN_RESOLVE_MODAL}`, resolve, { root: true });
            commit(`auth/${SET_PERSISTENT_LOGIN_MODAL_SHOWN}`, true, { root: true });
        });
        commit(`auth/${SET_PERSISTENT_LOGIN_ACTIVE_PROMISE}`, promise, { root: true });
        return promise;
    },
    async handlePersistentLogin({ rootGetters, dispatch }) {
        const persistentLoginDetails = rootGetters['auth/persistentLoginDetails'];
        if (persistentLoginDetails.modalAnswered) {
            return;
        }
        if (persistentLoginDetails.modalPending) {
            await persistentLoginDetails.activeModalPromise;
            return;
        }
        if (await shouldShowModal(rootGetters, dispatch)) {
            await dispatch('handlePersistentLoginModalShown');
        }
    },
    resolveLogout() {
        const relativeUrl = window.location.pathname + window.location.search;
        new UtdCache().setPersistent('ssoRedirectURL', relativeUrl, 1);
        new UtdCache().removeSession('utdMessageBannerData');
        new PubSub().publish('wkutd.purgePersistentCache');
        new ServerMessaging().clearMessageQueue();
        new UtdCache().removeSession(C_PRIORITY_LOGIN.PATHWAY_REDIRECT_CACHE_KEY);
        deleteCookie(C_PRIORITY_LOGIN.PATHWAY_REDIRECT_CACHE_KEY, { path: '/' });
    },
    async getRegistrationForm({ commit }) {
        try {
            const regForm = await utdRest('register/info');
            processRegistrationFormResponse({ commit }, regForm);
        }
        catch {
            getWindow().location.href = 'page-not-found';
        }
    },
    setIapRegistrationForm({ commit }) {
        commit(SET_REGISTRATION_FORM, {
            formName: 'INTERNATIONAL',
            isSuccess: true,
            formFields: {
                firstName: { isHidden: false, isEditable: true, required: true, maxLength: 80 },
                lastName: { isHidden: false, isEditable: true, required: true, maxLength: 80 },
                email: { isHidden: false, isEditable: true, required: true },
                country: { isHidden: false, isEditable: true },
                registrationUserName: {
                    isHidden: false, isEditable: true, required: true, maxLength: 100
                },
                password: { isHidden: false, isEditable: true, required: true },
                verifyPassword: { isHidden: false, isEditable: true, required: true }
            }
        });
        commit(SET_IS_TWO_FACTOR_ENABLED, true);
    },
    async sendOtcEmail(_, email) {
        await utdRest('register/send-otc', { email });
    }
};

function processRegistrationFormResponse({ commit }, regForm) {
    const formFieldBundle = regForm?.formFieldBundle || {};
    setRegFormFieldValues({ commit }, formFieldBundle);
    if (!regForm) {
        return;
    }
    setRegInfoValues({ commit }, regForm);
}

function setRegFormFieldValues({ commit }, formFieldBundle) {
    const formFields = {};
    formFieldBundle.formFields?.forEach(field => {
        if (field.name) {
            formFields[field.name] = field;
        }
        else if (field.value) {
            formFields[field.value] = field;
        }
    });
    commit(SET_REGISTRATION_FORM, {
        formName: formFieldBundle.formName,
        isSuccess: formFieldBundle.isSuccess,
        isLoaded: true,
        formFields
    });
}

function setRegInfoValues({ commit }, regForm) {
    commit(SET_CAN_CONTINUE_WITH_SEARCH, regForm.canContinueWithSearch || false);
    commit(SET_CONTINUE_WITH_SEARCH_LINK, regForm.continueWithSearchLink || false);
    commit(SET_IS_TWO_FACTOR_ENABLED, regForm.isTwoFactorEnabled || false);
    commit(SET_IS_TWO_FACTOR_DEFERRED, regForm.isTwoFactorDeferred || false);
    commit(SET_TWO_FACTOR_MAX_CODES_PER_SESSION,
        regForm.twoFactorEmailVerificationMaxCodesPerSession ?? null);
    commit(SET_SHOULD_SUGGEST_MERGE, regForm.shouldSuggestMerge || false);
}

async function postProcessLogin({ rootGetters, dispatch }, data, url) {
    let targetUrl = C_HTTP.DEFAULT_HOMEPAGE_PATH;
    if (data?.isRedirect) {
        return;
    }
    if (data && !data.isRedirect) {
        targetUrl = await getPostLoginRedirectTarget(rootGetters, url, '/contents/search');
    }
    if (rootGetters['auth/isOidcUser']) {
        targetUrl = processOidcPartnerModal(targetUrl, dispatch);
    }

    await dispatch('handlePersistentLogin');

    handlePostLoginRedirect({ rootGetters }, targetUrl);
}

function processOidcPartnerModal(targetUrl, dispatch) {
    if (shouldAttachMergeSuccessParam(targetUrl)) {
        targetUrl = setQueryParamValue(
            targetUrl,
            C_REG_MERGE.REG_MERGE_SUCCESS_PARAM,
            C_REG_MERGE.MESSAGES.BYOL_MERGE.name
        );
    }
    dispatch('setOidcPartnerModalShown');
    return targetUrl;
}

function handlePostLoginRedirect({ rootGetters }, targetUrl) {
    const utdAIURL = rootGetters['app/utdAIURL'];
    if (utdAIURL && targetUrl.startsWith(utdAIURL)) {
        getWindow().location.href = targetUrl;
    }
    else {
        rootGetters['app/router'].url(targetUrl);
    }
}

function normalizeDefaultPreferenceApp(preferenceApp) {
    if (typeof preferenceApp !== 'string') {
        return '';
    }
    return preferenceApp.trim().toUpperCase();
}

function shouldAttachMergeSuccessParam(targetUrl) {
    return typeof targetUrl === 'string' && targetUrl.startsWith('/');
}

function getXaiRedirectUrl(rootGetters) {
    const utdAIURL = rootGetters['app/utdAIURL'];
    if (typeof utdAIURL !== 'string') {
        return '';
    }
    return utdAIURL.trim();
}

async function getDefaultPreferenceApp(rootGetters) {
    const preferenceFromStore = normalizeDefaultPreferenceApp(
        rootGetters['account/myAccountDefaultPreferenceApp']
    );
    if (preferenceFromStore) {
        return preferenceFromStore;
    }

    try {
        const response = await utdRest('myAccount/defaultPreferenceApp');
        return normalizeDefaultPreferenceApp(response?.defaultPreferenceApp);
    }
    catch {
        return '';
    }
}

function getPreferredPostLoginUrlForPreference(preferenceApp, rootGetters, defaultUrl) {
    if (preferenceApp === C_DEFAULT_PREFERENCE.APP_XAI) {
        return getXaiRedirectUrl(rootGetters) || defaultUrl;
    }
    if (preferenceApp === C_DEFAULT_PREFERENCE.APP_UTD) {
        return '/contents/search';
    }
    if (preferenceApp === C_DEFAULT_PREFERENCE.APP_NONE) {
        return defaultUrl;
    }
    return defaultUrl;
}

async function getPostLoginRedirectTarget(rootGetters, destinationUrl, defaultUrl) {
    if (destinationUrl) {
        return destinationUrl;
    }

    if (!rootGetters['feature/hasExpertClinicianFlag']) {
        return defaultUrl;
    }
    const preferenceApp = await getDefaultPreferenceApp(rootGetters);
    const preferredUrl = getPreferredPostLoginUrlForPreference(
        preferenceApp,
        rootGetters,
        defaultUrl
    );

    return preferredUrl;
}

async function shouldShowModal(rootGetters, dispatch) {
    await dispatch('app/confirmConfigLoaded', null, { root: true });
    const cache = new UtdCache();
    if (cache.getPersistent('isXAIMobile')) {
        cache.removePersistent('isXAIMobile');
        return false;
    }
    if (rootGetters['feature/isPersistentLoginEnabled']
        && rootGetters['auth/persistentLoginDetails'].isEligible) {
        const cookieValue = getCookie('_utd_plq');
        return cookieValue !== 'false' && cookieValue !== 'true';
    }
    return false;
}

const login = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};

export default login;
